
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Container from "../ui/Container";
import { clients } from "../../data/clients";

const Clients = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute left-1/4 top-1/4 w-1/4 h-1/4 bg-accent/5 rounded-full blur-3xl"></div>
        <div className="absolute right-1/4 bottom-1/4 w-1/4 h-1/4 bg-primary/5 rounded-full blur-3xl"></div>
      </div>

      <Container>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="tag mb-4 mx-auto inline-block">Наши клиенты</div>
          <h2 className="heading text-3xl md:text-4xl font-bold mb-6">
            Они <span className="text-gradient">доверяют нам</span> свой бизнес
          </h2>
          <p className="text-muted-foreground text-lg">
            Мы гордимся сотрудничеством с ведущими компаниями в различных отраслях. Наши решения помогают им оптимизировать процессы и достигать новых высот.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-16">
          {clients
            .filter(client => client.status === 'active')
            .map((client, index) => (
              <div
                key={index}
                className="aspect-[4/3] bg-white rounded-2xl flex items-center justify-center p-6 border border-border hover:border-primary/20 hover:shadow-md transition-all duration-300"
              >
                <div className="w-28 h-28 rounded-full flex items-center justify-center">
                  <img src={client.logo_url} alt={client.name} className="w-28 h-28 object-contain" />
                </div>
              </div>
            ))}
        </div>
      
        <div className="max-w-4xl mx-auto">
          <div className="glass rounded-2xl p-8 md:p-10">
            <div className="flex flex-col md:flex-row md:items-center md:space-x-10">
              <div className="mb-6 md:mb-0 md:w-2/3">
                <h3 className="text-2xl font-semibold mb-4">Хотите узнать больше о наших проектах?</h3>
                <p className="text-muted-foreground">
                  Посмотрите наши кейсы и истории успеха, чтобы узнать, как мы помогаем бизнесу развиваться с помощью инновационных технологий.
                </p>
              </div>
              <div className="md:w-1/3 text-center md:text-right">
                <Link to="/clients" className="button-primary">
                  Смотреть кейсы
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Clients;
